import { render, staticRenderFns } from "./MADDList.vue?vue&type=template&id=22f3a09c"
import script from "./MADDList.vue?vue&type=script&lang=js"
export * from "./MADDList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22f3a09c')) {
      api.createRecord('22f3a09c', component.options)
    } else {
      api.reload('22f3a09c', component.options)
    }
    module.hot.accept("./MADDList.vue?vue&type=template&id=22f3a09c", function () {
      api.rerender('22f3a09c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/MADD/MADDList.vue"
export default component.exports